import {Text, Tooltip} from "@blueprintjs/core";
import styled from "@emotion/styled";
import {extractSimplePref, usePreferenceContext} from "../../../../providers/PreferenceProvider";
import {Constants, TenantPreferences} from "../../../../constants/constants";
import {DEFAULT_GPS_FREQUENCY_MINUTES} from "../../../settings/CompanySettings/common/constants";
import {useFeatureFlagContext} from "../../../../providers/FeatureFlagProvider";
import {FrequencyIcon, GPSIcon} from "../../../common/icons";

export const ETAServiceStatus = () => {
  const {tenantPreferences} = usePreferenceContext();
  const {etas: isETAEnabled} = useFeatureFlagContext();
  const [isUseETAService, isUseGPSPoints, gpsFrequency] = [
    extractSimplePref(tenantPreferences, TenantPreferences.useEtaService, true).value,
    extractSimplePref(tenantPreferences, TenantPreferences.useGPSPoints, true).value,
    extractSimplePref(tenantPreferences, TenantPreferences.gpsFrequency, DEFAULT_GPS_FREQUENCY_MINUTES).value
  ];

  const renderToolTipContent = () => {
    if (!isUseGPSPoints) {
      return (
        <>
          Your ETAs are refreshed with completed stops. If you’d like GPS points to update your ETAs please have a
          primary admin{" "}
          <StyledLink href={Constants.ETA_PREMIUM_CONSULT_URL} target="_blank">
            submit a request
          </StyledLink>{" "}
          to discuss.
        </>
      );
    }
    if ([1, 3, 5].includes(gpsFrequency as number)) {
      return (
        <>
          Your ETA functionality has been upgraded to refresh with completed stops and via GPS updates every{" "}
          {gpsFrequency} minutes.
        </>
      );
    }

    return (
      <>
        Your ETAs are refreshed with completed stops and GPS updates every 15 minutes. If more frequent GPS updates or
        stops per update are desired, please have a primary admin{" "}
        <StyledLink href={Constants.ETA_PREMIUM_CONSULT_URL} target="_blank">
          submit a request
        </StyledLink>
        .
      </>
    );
  };

  if (!isUseETAService || !isETAEnabled) return null;

  return (
    <Tooltip
      popoverClassName="white-popover"
      content={
        <StyledTooltipContainer data-testid={"eta-tooltip-container"}>{renderToolTipContent()}</StyledTooltipContainer>
      }
      position={"right"}
      interactionKind={"hover"}
    >
      <Container data-testid={"eta-service-status"}>
        {isUseGPSPoints && <GPSIcon />}
        <FrequencyIcon />
        {isUseGPSPoints ? <StyledText>{gpsFrequency}m</StyledText> : <StyledText>Comp. Stops</StyledText>}
      </Container>
    </Tooltip>
  );
};

const Container = styled.div`
  font-family: "Roboto", sans-serifs;
  background: #f3f4f6;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 4px;
  width: fit-content;
  height: 24px;
  padding: 4px 8px;
  font-weight: 500;
  border-radius: 12px;
  cursor: pointer;
`;

const StyledText = styled(Text)`
  font-size: 12px;
  color: #797979;
  line-height: normal;
`;

const StyledTooltipContainer = styled.div`
  min-width: 300px;
  max-width: 400px;
  font-size: 14px;
`;

const StyledLink = styled.a`
  color: #406aff !important;
  font-weight: 500;
`;
